import React, { useState } from 'react';
import { motion } from 'framer-motion';
import TechIcon from '../../Utils/Icons/Icons';
import PopUpModal from './PopUpModal';

const PositionItem = ({ position, allCountries, initialCountries }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showApplication, setShowApplication] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleApplyClick = (e) => {
    e.stopPropagation();
    setShowApplication(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseApplication = () => {
    setShowApplication(false);
    document.body.style.overflow = 'unset';
  };

  const cardVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <>
      <motion.div
        className="positionContainer"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={cardVariants}
      >
        <div className={`positionCard ${showApplication ? 'blurred' : ''}`}>
          <div className="positionHeader" onClick={toggleOpen}>
            <div className="positionHeaderLeft">
              <div className="positionTitleRow">
                <span className="positionCategory">{position.category}</span>
                <span className="positionSeparator">-</span>
                <span className="positionTitle">{position.title}</span>
              </div>
              <p className="positionDescription">{position.description}</p>
              <div className="positionMeta">
                <span className="positionMetaItem">
                  <TechIcon name="clock" /> {position.type}
                </span>
                <span className="positionMetaItem">RS. {position.salary}</span>
              </div>
            </div>
            <button className="viewMoreBtn">
              {isOpen ? "View Less" : "View More"} 
              <TechIcon name={isOpen ? "chevron-up" : "chevron-down"} />
            </button>
          </div>
          
          <div className={`positionDetails ${isOpen ? 'open' : ''}`}>
            <div className="positionContent">
              <div className="contentSection">
                <h4>About Softations.</h4>
                <p>{position.aboutCompany}</p>
              </div>
              <div className="contentSection">
                <h4>The Opportunity</h4>
                <p>{position.opportunity}</p>
              </div>
              <div className="contentSection">
                <h4>What You'll Do</h4>
                <ul>
                  {position.whatYouDo.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
              </div>
              <div className="contentSection">
                <h4>Required Skills</h4>
                <ul>
                  {position.requiredSkills.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
              </div>
              
              <div className="positionFooter">
                <div className="footerMeta">
                  <span className="footerMetaItem">RS. {position.salary}</span>
                </div>
                <button className="applyNowBtn" onClick={handleApplyClick}>
                  Apply now!
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {showApplication && (
        <PopUpModal 
          position={position}
          onClose={handleCloseApplication}
          allCountries={allCountries}
          initialCountries={initialCountries}
        />
      )}
    </>
  );
};

export default PositionItem;